import * as React from "react";
const SvgFiRrPlaceOfWorship = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-place-of-worship_svg__a)">
      <path
        fill="#062147"
        d="M21.906 11.49 17 7.986V4.5c0-.938-.448-1.835-1.2-2.4l-2-1.5a3.015 3.015 0 0 0-3.6 0L8.199 2.1A3.02 3.02 0 0 0 7 4.5v3.445l-5.019 3.8A5.03 5.03 0 0 0 0 15.733V20c0 2.206 1.794 4 4 4h16c2.206 0 4-1.794 4-4v-4.441a5.01 5.01 0 0 0-2.094-4.07M8.603 9.24a1 1 0 0 0 .396-.797V4.5c0-.313.149-.612.399-.8l2-1.5a1.01 1.01 0 0 1 1.202 0l1.999 1.5c.251.188.4.488.4.8v4a1 1 0 0 0 .419.815l1.581 1.129v11.557h-2v-4c0-1.654-1.346-3-3-3s-3 1.346-3 3v4h-2V10.456l1.604-1.214zM12.999 22h-2v-4a1.001 1.001 0 0 1 2 0zm-11-2v-4.268c0-.934.444-1.828 1.188-2.392l1.812-1.372v10.03h-1c-1.103 0-2-.895-2-1.998m20 0c0 1.103-.897 2-2 2h-1V11.872l1.744 1.246a3 3 0 0 1 1.256 2.44zm-11.5-8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 10.5 11.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-place-of-worship_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaceOfWorship;
